module.exports = __webpack_public_path__ + "img/bg4.816c01fe.jpg";